import candidatesReducer from './candidates/reducers'
import { configureStore } from '@reduxjs/toolkit'
import jobPositionsReducer from './jobPositions/reducers'
import logger from 'redux-logger'
import settingReducer from './settings/reducers'
import tourReducer from './tour/reducers'
import usersReducer from './users/reducers'
import administrationsReducer from './administrations/reducers'
import interviewSlotsReducer from './interviews/reducers'
import jobStatsReducer from './jobStats/reducer'
import sectorsReducer from './sectors/reducer'

const store = configureStore({
  reducer: {
    candidates: candidatesReducer,
    tour: tourReducer,
    jobPositions: jobPositionsReducer,
    users: usersReducer,
    settings: settingReducer,
    administrations: administrationsReducer,
    interviewSlots: interviewSlotsReducer,
    jobStats: jobStatsReducer,
    sectors: sectorsReducer,
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  devTools: process.env.NODE_ENV !== 'production',
})

export default store
